import { render, staticRenderFns } from "./wxActPlace.vue?vue&type=template&id=82f10c2c"
import script from "./wxActPlace.vue?vue&type=script&lang=js"
export * from "./wxActPlace.vue?vue&type=script&lang=js"
import style0 from "./wxActPlace.vue?vue&type=style&index=0&id=82f10c2c&prod&lang=scss"
import style1 from "./wxActPlace.vue?vue&type=style&index=1&id=82f10c2c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports